import SelaTranscriptMobile from './component.jsx'
export default SelaTranscriptMobile
